import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthGuardService } from './auth-guard.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardAlertHandling implements CanActivate {
    constructor(private _authGuardService: AuthGuardService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this._authGuardService.canActivateAlertHandling(route, state);
    }
}
